import {baseUrl, fetchAndParse, headers} from "./utils";
import {QuestionsQuery} from "../Models/Question";

export const retrieveQuestions = () => {
  const url = new URL(`/questions/?limit=999`, baseUrl);
  return fetchAndParse<QuestionsQuery>(url.toString(), { method: "GET", headers })
}

